import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrending6"><Path fillRule="evenodd" clipRule="evenodd" d="M14.9982 18H21.9982V11H20.4982V15.4293L12.9978 7.93971L8.99816 11.9393L2.74816 5.68933L1.6875 6.74999L8.99816 14.0607L12.9985 10.0603L19.4475 16.5H14.9982V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending6;
